import { useState } from "react";
import { SearchBySucursal } from "./SearchBySucursal";
import { SearcherByExtension } from "./SearcherByExtension";
import { SearcherByNombre } from "./SearcherByNombre";
// import { SearchByDepartamento } from "./SearchByDepartamento";
// import { SearcherByProvincia } from "./SearcherByProvincia";
// import { SearcherByPuesto } from "./SearcherByPuesto";
// import { SearcherByTelefono } from "./SearcherByTelefono";


// OJO: NO CAMBIAR EL VALOR DEL KEY YA QUE LA MISMA ESTA EMPAREJADO CON EL SP DE DB
export const KEY = {
    PUESTO: 1,
    DEPARTAMENTO: 2,
    NOMBRE: 3,
    TELEFONO: 4,
    EXTENSION: 5,
    SUCURSAL: 6
};

export const useFields = (initialState = {}) => {


    const [props, setaddProps] = useState(initialState);

    const reset = () => {
        setaddProps(initialState);
    }

    const handleInputChange = ({ target }) => {

        setaddProps({
            ...props,
            [target.name]: target.value
        });

    }



    const items = [
        {
            key: KEY.NOMBRE,
            text: 'Nombre',
            value: '',
            Component: <SearcherByNombre {...props} handleInputChange={handleInputChange} />
        },
        // {
        //     key: KEY.PUESTO,
        //     text: 'Cargo',
        //     value: '',
        //     Component: <SearcherByPuesto {...props} handleInputChange={handleInputChange} />

        // },
        // {
        //     key: KEY.DEPARTAMENTO,
        //     text: 'Departamento',
        //     value: '',
        //     Component: <SearchByDepartamento {...props} handleInputChange={handleInputChange} />

        // },
        {
            key: KEY.SUCURSAL,
            text: 'Sucursal',
            value: '',
            Component: <SearchBySucursal {...props} handleInputChange={handleInputChange} />
        },
        // {
        //     key: KEY.TELEFONO,
        //     text: 'Linea Directa',
        //     value: '',
        //     Component: <SearcherByTelefono {...props} handleInputChange={handleInputChange} />
        // },
        {
            key: KEY.EXTENSION,
            text: 'Extension',
            value: '',
            Component: <SearcherByExtension {...props} handleInputChange={handleInputChange} />

        }
    ];


    return {
        items,
        props,
        setaddProps,
        handleInputChange,
        reset
    }

}

